
function DayThree({content}) {

    window.document.body.style.backgroundColor = "#FFFCF9";
    window.document.body.style.color = "#16324f";

  return (
    <div className="day place-items-center content-center" id="daythree">
    
                <div className="m-10 p-4 text-4xl lg:text-5xl" >Türchen 3 </div>
    <div className="text-xl content-center w-11/12 md:w-1/2 place-items-center">
    <div className="place-items-center w-11/12 lg:w-1/2">
    <div className="pb-5">
    Dankbarkeitstagebuch: Notiert euch ab heute jeden Tag eine Sache, für die ihr eurem Partner dankbar seid. Am Sonntag lest ihr dem jeweils anderen vor.

    </div>
      </div>
   </div>
    </div>

  );
}

export default DayThree;